import React from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { Shield } from "lucide-react";

const TODAY = new Date().toLocaleDateString("es-MX", { day: "numeric", month: "long", year: "numeric" });

export default function Privacy() {
  return (
    <div className="min-h-screen bg-background">
      <Navbar />
      <section className="max-w-3xl mx-auto px-6 pt-14 pb-20">
        <div className="flex items-center gap-3 mb-4">
          <div className="w-12 h-12 rounded-xl bg-emerald-100 grid place-items-center">
            <Shield className="w-6 h-6 text-emerald-700" />
          </div>
          <div>
            <div className="overline text-emerald-700">Legal · OFERTAS</div>
            <h1 className="font-display text-4xl sm:text-5xl tracking-tight">Aviso de Privacidad</h1>
          </div>
        </div>
        <p className="text-base text-muted-foreground mt-3">Última actualización: {TODAY}</p>

        <article className="mt-8 text-base leading-relaxed text-zinc-800 space-y-7">
          <Section title="1. Identidad del responsable">
            <p>
              En cumplimiento a lo dispuesto por la <strong>Ley Federal de Protección de Datos Personales en Posesión de los Particulares</strong> (LFPDPPP), su Reglamento y demás disposiciones aplicables, se hace de su conocimiento que el responsable del tratamiento de sus datos personales es:
            </p>
            <div className="bg-[#F5F3FF] border border-[#DDD6FE] rounded-2xl p-5">
              <strong>Marketing de Inteligencia Artificial S. de R.L. de C.V.</strong><br />
              Av. Las Américas 1545, pisos 20, 21 y 22, Col. Providencia,<br />
              Guadalajara, Jalisco, México.<br />
              Teléfono: 33 1738 1875 · Correo: hola@ofertas.mx<br />
              <span className="text-sm text-muted-foreground">Responsable designado: Sr. <strong>Ricardo Zermeño Mejía</strong>.</span>
            </div>
          </Section>

          <Section title="2. Datos personales que recabamos">
            <p>Dependiendo del tipo de usuario, podemos recabar los siguientes datos:</p>
            <ul className="list-disc pl-6 space-y-2">
              <li><strong>Comercios:</strong> nombre del negocio, giro, domicilio, código postal, número de WhatsApp, correo electrónico, logotipo, anuncios e imágenes que publiquen y comprobantes de pago.</li>
              <li><strong>Clientes:</strong> nombre, número de WhatsApp, contraseña encriptada, puntos acumulados por comercio y boletos digitales para la rifa.</li>
              <li><strong>Promotores:</strong> nombre, domicilio, teléfono, contraseña encriptada y datos para el pago de comisiones.</li>
              <li><strong>Datos de navegación:</strong> dirección IP, tipo de navegador, páginas visitadas, registros de inicio de sesión y métricas de uso de la Plataforma.</li>
            </ul>
            <p>
              No recabamos datos personales sensibles (origen racial, estado de salud, creencias religiosas, orientación sexual, datos biométricos, etc.).
            </p>
          </Section>

          <Section title="3. Finalidades del tratamiento">
            <p><strong>Finalidades primarias</strong> (necesarias para prestar el servicio):</p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Crear y administrar tu cuenta en la Plataforma.</li>
              <li>Procesar los pagos de afiliación de los Comercios y las comisiones de los Promotores.</li>
              <li>Operar el programa de lealtad, la entrega de puntos y la rifa mensual.</li>
              <li>Notificarte cambios en tu cuenta, en tu suscripción o en tu participación en la rifa.</li>
              <li>Cumplir con obligaciones fiscales y legales aplicables.</li>
            </ul>
            <p><strong>Finalidades secundarias</strong> (no necesarias pero útiles para mejorar el servicio):</p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Enviarte comunicaciones promocionales sobre nuevas funciones u ofertas relevantes.</li>
              <li>Realizar análisis estadísticos anonimizados para mejorar la Plataforma.</li>
              <li>Mostrar a otros usuarios el primer nombre del ganador y los últimos 4 dígitos de su teléfono en la página pública de ganadores, como evidencia de la rifa.</li>
            </ul>
            <p>Si no deseas que tus datos sean tratados para las finalidades secundarias, puedes manifestarlo enviando un correo a <strong>hola@ofertas.mx</strong>.</p>
          </Section>

          <Section title="4. Transferencias de datos">
            <p>
              Tus datos no serán vendidos ni transferidos a terceros sin tu consentimiento, salvo en los siguientes casos previstos por la LFPDPPP: (a) cuando lo exija una autoridad competente; (b) para el cumplimiento de obligaciones fiscales o legales; y (c) a proveedores tecnológicos que actúan como encargados (por ejemplo, servicios de hosting y mensajería) bajo cláusulas de confidencialidad.
            </p>
          </Section>

          <Section title="5. Derechos ARCO">
            <p>
              Tienes derecho a <strong>Acceder, Rectificar, Cancelar u Oponerte</strong> al tratamiento de tus datos personales (derechos ARCO), así como a revocar el consentimiento otorgado. Para ejercerlos, envía una solicitud por escrito a <strong>hola@ofertas.mx</strong> indicando tu nombre completo, copia de una identificación oficial, descripción clara del derecho que deseas ejercer y, en su caso, los documentos que sustenten tu petición.
            </p>
            <p>
              Atenderemos tu solicitud en un plazo máximo de <strong>20 días hábiles</strong> conforme al artículo 32 de la LFPDPPP.
            </p>
          </Section>

          <Section title="6. Conservación de los datos">
            <p>
              Conservaremos tus datos durante el tiempo que mantengas una cuenta activa y por los plazos posteriores que exija la normatividad fiscal y mercantil aplicable. Una vez transcurridos esos plazos, los datos serán eliminados o anonimizados de manera segura.
            </p>
          </Section>

          <Section title="7. Medidas de seguridad">
            <p>
              Implementamos medidas técnicas, administrativas y físicas razonables para proteger tus datos personales contra pérdida, uso indebido o acceso no autorizado, incluyendo el cifrado de contraseñas, conexiones HTTPS y controles de acceso a la base de datos.
            </p>
          </Section>

          <Section title="8. Uso de cookies y tecnologías similares">
            <p>
              La Plataforma puede utilizar cookies y almacenamiento local para mantener tu sesión iniciada y recordar tus preferencias. Puedes deshabilitarlas desde la configuración de tu navegador, aunque algunas funciones podrían dejar de operar correctamente.
            </p>
          </Section>

          <Section title="9. Cambios al Aviso de Privacidad">
            <p>
              Nos reservamos el derecho de modificar este Aviso. Cualquier cambio relevante será comunicado mediante la publicación de la versión actualizada en esta misma página, indicando la fecha de última actualización. Te invitamos a revisarlo periódicamente.
            </p>
          </Section>

          <Section title="10. Contacto del responsable">
            <p>
              Si tienes dudas sobre el tratamiento de tus datos personales, puedes contactar al responsable designado, <strong>Sr. Ricardo Zermeño Mejía</strong>, en:
            </p>
            <p>
              <strong>Marketing de Inteligencia Artificial S. de R.L. de C.V.</strong><br />
              Av. Las Américas 1545, pisos 20, 21 y 22, Col. Providencia, Guadalajara, Jalisco, México.<br />
              Tel. 33 1738 1875 · <a href="mailto:hola@ofertas.mx" className="text-[#7C3AED] underline">hola@ofertas.mx</a>
            </p>
            <p className="text-sm text-muted-foreground">
              Asimismo, en caso de considerarlo necesario, puedes acudir al <strong>Instituto Nacional de Transparencia, Acceso a la Información y Protección de Datos Personales (INAI)</strong> para más información, en <a href="https://home.inai.org.mx" target="_blank" rel="noopener noreferrer" className="text-[#7C3AED] underline">home.inai.org.mx</a>.
            </p>
          </Section>
        </article>
      </section>
      <Footer />
    </div>
  );
}

const Section = ({ title, children }) => (
  <section>
    <h2 className="font-display text-2xl tracking-tight text-zinc-900">{title}</h2>
    <div className="mt-3 space-y-3 text-zinc-700">{children}</div>
  </section>
);
